module.exports = __webpack_public_path__ + "static/assets/238e6e3168377669201e4f760032b4d3.png";